<template>
    <div class="video-filerequest-wrapper">
        <h2>Third Party Upload</h2>
        <div class="description black"><p>  To have someone upload files on your behalf, click but button below. Type their email in the pop up and add any comments to the uploader about what videos to upload.</p></div>
        <a href="" class="btn  btn-create-gold display-inline" @click.prevent="modalTrigger = true"><i class="fa fa-envelope-o"></i>  Request Video Files</a>

        <div class="green" v-if="status">{{ status }}</div>
        <modal v-if="modalTrigger" @close="clearFieldsAndClose()" modalclass="video-file-request-modal">
            <h3 slot="header">Video File Request</h3>
            <div class="content" slot="body">
                <div class="form-group entry-field">
                    <label class="entry-field__label" for="modal_email_address">Email Address:<em class="yellow no-style"> *</em></label>
                    <input id="modal_email_address" class="form-control modal-email" v-model="email" required>
                </div>
                <div class="form-group entry-field">
                    <label class="entry-field__label" for="modal_comments">Comments for Uploader:</label>
                    <textarea id="modal_comments" class="modal-comments" v-model="comments"></textarea>
                </div>

            </div>
            <div class="form-group-submit clearfix" slot="footer">
                <button class="pull-left btn btn-cancel btn-transparent" @click="clearFieldsAndClose()">Cancel</button>
                <button class=" pull-right" @click.prevent="applyChange">Send</button>
            </div>
        </modal>
    </div>
</template>

<script>

    import modal from './Modal.vue';
    import axios from 'axios';
    export default {
        props: [],
        components: {modal},
        data() {
            return {
                modalTrigger: false,
                comments: '',
                email: '',
                status: '',
            }
        },
        methods: {
            applyChange: function() {
                let app = this;
                let actionUrl = '/api/video/filerequest';
                axios(
                    {
                        method: 'POST',
                        url: actionUrl,
                        data: {
                            email: app.email,
                            comments: app.comments
                        }
                    }).then(function(response) {
                        app.status = `Video file request sent to ${app.email}`;
                        app.clearFieldsAndClose();
                }).catch(function (error) {
                    // handle error
                    console.log('This is the error returned', error);
                    alert('Video file request failed to send. Please try again.');
                    app.modalTrigger = false;
                });
            },
            clearFieldsAndClose: function() {
                let app = this;
                app.modalTrigger = false;
                app.email = '';
                app.comments = '';
            }
        }
    }
</script>

<style>
    .display-inline {
        display: inline-block;
    }
    .video-file-request-modal .modal-container {
        width: 600px;
    }
</style>
